module.exports = __webpack_public_path__ + "static/media/spinner.a31aa0fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spinner.svg
// module id = 1821
// module chunks = 0